export enum PassportRequirementLevel {
  NoPassport = 'no_passport_required',
  RequiredToRegister = 'passport_required_to_register',
  RequiredToRegisterAndView = 'passport_required_to_register_and_view',
}

export enum PassportNeededFor {
  OnlyBuyer = 'only_buyer',
  BuyerAndAttendee = 'buyer_and_attendee',
}

export const normalizePassportLevel = (value: unknown): PassportRequirementLevel => {
  if (value === true) return PassportRequirementLevel.RequiredToRegister;
  if (!value) return PassportRequirementLevel.NoPassport;
  return value as PassportRequirementLevel;
};
